import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

// the watermark tint is not in the palette
const GHOST_COLOR = '#f4f0f9'

export const Page = styled.main`
  background: ${colors.white100};
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  overflow: hidden;
  position: relative;
`

export const Ghost = styled.div`
  align-items: center;
  color: ${GHOST_COLOR};
  display: flex;
  font-size: clamp(220px, 36vw, 520px);
  font-weight: 700;
  inset: 0;
  justify-content: center;
  letter-spacing: -0.06em;
  line-height: 1;
  padding-top: 40px;
  pointer-events: none;
  position: absolute;
  user-select: none;
  z-index: 0;
`

export const Top = styled.header`
  align-items: center;
  display: flex;
  padding: 22px 40px;
  position: relative;
  z-index: 1;
`

export const Logo = styled.img.attrs({ src: '/images/logo.png', alt: 'skefto' })`
  display: block;
  height: 30px;
  width: auto;
`

export const Content = styled.section`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px 60px;
  position: relative;
  text-align: center;
  z-index: 1;
`

export const Code = styled.p`
  color: ${colors.purple400};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.14em;
  margin: 0 0 14px;
  text-transform: uppercase;
`

export const Title = styled.h1`
  color: ${colors.black700};
  font-size: 30px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0;
`

export const Text = styled.p`
  color: ${colors.gray900};
  font-size: 17px;
  line-height: 1.6;
  margin: 12px 0 0;
  max-width: 520px;
  text-wrap: pretty;
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
  margin-top: 32px;
`
